module.exports = __webpack_public_path__ + "er.3db012ff5bcd64a3efb3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/er.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/er.svg
// module chunks = styles